"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertAlgoToXAlgoWhenImmediate = convertAlgoToXAlgoWhenImmediate;
exports.convertAlgoToXAlgoWhenDelay = convertAlgoToXAlgoWhenDelay;
exports.convertXAlgoToAlgo = convertXAlgoToAlgo;
const math_lib_1 = require("../math-lib");
function convertAlgoToXAlgoWhenImmediate(algoAmount, consensusState) {
    const { algoBalance, xAlgoCirculatingSupply, premium } = consensusState;
    return (0, math_lib_1.mulScale)((0, math_lib_1.mulScale)(algoAmount, xAlgoCirculatingSupply, algoBalance), math_lib_1.ONE_16_DP - premium, math_lib_1.ONE_16_DP);
}
function convertAlgoToXAlgoWhenDelay(algoAmount, consensusState) {
    const { algoBalance, xAlgoCirculatingSupply } = consensusState;
    return (0, math_lib_1.mulScale)(algoAmount, xAlgoCirculatingSupply, algoBalance);
}
function convertXAlgoToAlgo(xAlgoAmount, consensusState) {
    const { algoBalance, xAlgoCirculatingSupply } = consensusState;
    return (0, math_lib_1.mulScale)(xAlgoAmount, algoBalance, xAlgoCirculatingSupply);
}
//# sourceMappingURL=formulae.js.map